<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
	@close='onClose'>
	<slot name='dialogBody'></slot >
    
    
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: {
      typeof: String,
      default: '',
    },
    visible:{
    	typeof:Boolean,
    	default:false
    },
	width: {
	  typeof: String,
	  default: '50%',
	},
  },
  data() {
    return {
		dialogVisible:false,
		
	}
  },
  watch: {},
  created() {
	  this.dialogVisible=this.visible
  },
  methods: {
	  onClose(){
		  console.log('关闭')
		  this.$emit('close')
	  }
  },
}
</script> 
<style scoped lang="scss">
	:deep(.el-dialog) {
		background: url('~@/assets/back/dialog.png');
		background-size: 100% 100%;
		
	}
	:deep(.el-dialog__header){
		height: 0.48rem;
		line-height: 0.48rem;
		background: rgba(239,171,68,0.2);
		border-radius: 0.05rem 0.05rem 0rem 0rem;
		padding: 0 .25rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	:deep(.el-dialog__title),:deep(.el-dialog__headerbtn){
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 500;
		font-size: 0.23rem;
		color: #EFAB44;
		height: 0.48rem;
		line-height: 0.48rem;
		position: relative;
		top: 0;
		right: 0;
		.el-dialog__close{
			color: rgba(239, 171, 68, 1);
		}
	}
</style>
